module.exports = __webpack_public_path__ + "static/img/identify_list.ef5cfb47.png";